import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

type PlumbingModalProps = {
  isVisible: boolean;
  onCancel: () => void;
};

const PlumbingModal = ({ isVisible, onCancel }: PlumbingModalProps) => {
  const { t } = useTranslation();
  const content: string[] = t('SCROLLABLE_AREA.PLUMBING.MODAL.CONTENT', {
    returnObjects: true,
  }) as string[];

  return (
    <Modal
      centered
      destroyOnClose
      open={isVisible}
      closable
      footer={null}
      width="40%"
      onCancel={onCancel}
      title={t('SCROLLABLE_AREA.PLUMBING.MODAL.TITLE')}
      keyboard
    >
      <div style={{ margin: '10px', fontSize: '14px' }}>
        {content.map((item, index) => (
          <p key={index}>{item}</p>
        ))}
      </div>
    </Modal>
  );
};

export default PlumbingModal;
